module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAA6SURBVDhPY/hPIgBr+Pnr/4UbhBEYgDV8//n/wGnCCAxGNRBAYDBsNADT0vkbhBEYgDWQAkjU8P8/AP9EuQfDAw3RAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./ClientApp/images/node-icons/refining-node.png
// module id = 994
// module chunks = 0